export class FeatureFlag {
  constructor(
    public readonly id: number,
    public readonly key: string,
    public readonly name: string,
    public readonly description: string | null,
    public readonly isActive: boolean,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {}

  /**
   * Check if this feature flag is currently active
   */
  isEnabled(): boolean {
    return this.isActive;
  }

  /**
   * Create a new FeatureFlag with updated active status
   */
  withActiveStatus(isActive: boolean): FeatureFlag {
    return new FeatureFlag(
      this.id,
      this.key,
      this.name,
      this.description,
      isActive,
      this.createdAt,
      new Date() // Updated timestamp
    );
  }

  /**
   * Create a new FeatureFlag with updated metadata
   */
  withUpdatedMetadata(name: string, description: string | null): FeatureFlag {
    return new FeatureFlag(
      this.id,
      this.key,
      name,
      description,
      this.isActive,
      this.createdAt,
      new Date() // Updated timestamp
    );
  }
}
